export interface IRole {
  id: string;
  displayName: string;
}

export const userRoles: IRole[] = [
  {
    id: 'ca310b8d-2f4a-44e0-a36e-957c202cd8d4',
    displayName: 'Super Admin',
  },
  {
    id: 'c495eb57-eb18-489e-9802-62c474e5645c',
    displayName: 'Admin',
  },
  {
    id: 'b4935647-30e4-4ed3-9074-dcac66c2f8ef',
    displayName: 'Operator',
  },
  {
    id: '84cc62c1-dabe-49d3-b16e-8b291232b285',
    displayName: 'Viewer',
  },
];

export interface IFlatUser {
  email: string,
  name: string,
  phoneNo: string,
  organization: string,
  roleId: string,
  _id: string,
  userId: string,
  parents?: string;
  groupId?:string;
  groupName?:string;
  isPasswordEnable?:boolean;
}
